import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as resultCodes from "../../constants/resultCodes";
import * as messageHelper from "../../helpers/messageHelper";
import * as responseHelper from "../../helpers/responseHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.GET_ALL_MARGINS:
            if (!responseHelper.isGetAllMarginsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MARGIN_LIST,
                    payload: {
                        marginList: response.data.marginList
                    }
                }
            ];
        case handlers.ADD_MARGIN:
        case handlers.EDIT_MARGIN:
        case handlers.REMOVE_MARGIN:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let marginRequests = [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_MARGINS
                    },
                    method: handlers.GET_ALL_MARGINS,
                    tabId: 0
                },
                {
                    type: actionTypes.MAIN_TAB_RELOAD_FORMULA_DATA
                }
            ];

            if (method === handlers.ADD_MARGIN) {
                marginRequests.push({
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.EDIT_MARGIN_MODAL
                    }
                });
            }

            if (method === handlers.EDIT_MARGIN) {
                marginRequests.push({
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.EDIT_MARGIN_MODAL
                    }
                });
            }

            if (state.pricing.colorantData.length > 0) {
                marginRequests.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_COLORANTS_DATA
                    },
                    method: handlers.PRICING_GET_COLORANTS_DATA,
                    tabId: 0
                });
            }

            if (state.pricing.baseInProductsData.length > 0 && state.pricing.activeProduct !== null) {
                marginRequests.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_BASE_IN_PRODUCTS_DATA,
                        params: {
                            productId: state.pricing.activeProduct.id
                        }
                    },
                    method: handlers.PRICING_GET_BASE_IN_PRODUCTS_DATA,
                    tabId: 0
                });
            }

            if (state.pricing.baseInProductPackagesData.length > 0 && state.pricing.activeProduct !== null) {
                marginRequests.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_BASE_IN_PRODUCTS_AND_PACKAGES_DATA,
                        params: {
                            productId: state.pricing.activeProduct.id
                        }
                    },
                    method: handlers.PRICING_GET_BASE_IN_PRODUCTS_AND_PACKAGES_DATA,
                    tabId: 0
                });
            }

            return marginRequests;
        case handlers.MOVE_UP_MARGIN:
        case handlers.MOVE_DOWN_MARGIN:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_MARGINS
                    },
                    method: handlers.GET_ALL_MARGINS,
                    tabId: 0
                },
                {
                    type: actionTypes.MAIN_TAB_RELOAD_FORMULA_DATA
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
